module.exports = __webpack_public_path__ + "static/media/amishroof.ea159ec1.gif";